<template>
    <div class="invite-wrapper">
<!--        <b-navbar toggleable="md" class="navbar navbar-light bg-light">-->
<!--            <div class="container">-->
<!--                <div class="row">-->
<!--                    <b-navbar-brand class="col-md-3">-->
<!--                        <router-link to="/">-->
<!--                            <img class="logo" src="@/assets/clubsaway-logo-mobile-d.svg">-->
<!--                        </router-link>-->

<!--                        &lt;!&ndash; clubsaway logo &ndash;&gt;-->
<!--                    </b-navbar-brand>-->

<!--                </div>-->
<!--            </div>-->
<!--        </b-navbar>-->

        <div class="">
            <router-view></router-view>
        </div>

        <tb-footer></tb-footer>
    </div>
</template>

<script>
    import TbFooter from '@/views/Footer.vue';
    import {api} from "@/repository/repository.js";

    export default {
        components: {
            TbFooter
        },

        computed: {
            user() {
                return this.$store.getters.user;
            }
        },

        methods: {
            logout() {
                api.get('/logout')
                    .then(response=>{
                        window.location = '/';
                        //
                    });
            }
        }
    }
</script>

<style lang="scss">
    .invite-wrapper {
        background-color: $color-white;
        color: $color-black;

        a.router-link-active {
            color: red;
        }

        .logo {
            max-width: 300px;
        }
        html{
            scroll-behavior: smooth;
        }
    }


</style>